import React from 'react'

type Props = {
  iconName: string;
  fontweight: string;
  iconFilled?: boolean;
  className?: string;
  onClick?: () => void;
  fontSize?: string;
  lineHeight?:string;
  color?:string
}

// const MaterialSymbol = (props: Props) => {
//   return (
//     <span style={{fontSize:props.fontSize, lineHeight:props.lineHeight, color:props.color}} onClick={props.onClick} className={`material-symbols-rounded confirm-icon ${props?.fontweight} ${props.className ? props.className : ""} ${props?.iconFilled ? "icon-filled" : ""}`}>
//       {props?.iconName}
//     </span>

    
//   )
// }

const MaterialSymbol = (props: Props) => {
  return (
    <span
      onClick={props.onClick}
      className={`material-symbols-rounded confirm-icon ${props.className || ""}`}
      style={{
        fontSize: props.fontSize,
        lineHeight: props.lineHeight,
        color: props.color,
        fontVariationSettings: `
          'FILL' ${props.iconFilled ? 1 : 0},
          'wght' ${props.fontweight || 400},
          'GRAD' 0,
          'opsz' 24
        `
      }}
    >
      {props.iconName}
    </span>
  );
};

export default MaterialSymbol